<template>
  <!-- 获取验证码弹窗 -->
  <el-dialog title="身份验证" width="600px" :show-close="false" custom-class="system-dialog" :visible.sync="dialogVisible"
    :close-on-press-escape="false" :close-on-click-modal="false" @close="handleClose">
    <div class="form-box">
      <div class="form-item">
        <div class="item-label">手机号：</div>
        <div class="item-value">
          <el-input disabled placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
        </div>
      </div>
      <div class="form-item">
        <div class="item-label">验证码：</div>
        <div class="item-value">
          <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
          <el-button type="primary" :disabled="codeDisabled || isLoadingPhone" @click="getCodeInit">{{ codeMsg
            }}</el-button>
        </div>
      </div>
      <div class="form-item" style="margin-bottom: 8px">
        <div class="form-item" style="margin-bottom: 8px">
          <div class="item-label"></div>
          <div class="item-value">
            <div class="tip-box" style="background: #fff"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="save-btn">
      <el-button type="primary" :disabled="isLoadingPhone" @click="handleConfirm">确定</el-button>
      <el-button type="default" @click="handleCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getmoble, getSellerCheckCode } from "@/api/paradiseAndTaskCommonController.js";

export default {
  name: "VerifyCodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      phone: "",
      code: "",
      countdown: 60,
      codeDisabled: false,
      codeMsg: "获取验证码",
      timer: null
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    isLoadingPhone() {
      if (!this.phone || this.phone == '') {
        return true
      }
      return false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initDialog();
      } else {
        this.resetDialog();
      }
    }
  },
  methods: {
    async initDialog() {
      this.code = "";
      try {
        const { data: res } = await getmoble();
        this.phone = res.mobile;
        this.countdown = 60;
        this.codeDisabled = false;
        this.codeMsg = "获取验证码";
        this.clearTimer();
      } catch (error) {
        console.error('获取手机号失败:', error);
        this.$message.error('获取手机号失败');
      }
    },

    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  this.clearTimer();
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        }).catch(error => {
          console.error('获取验证码失败:', error);
          this.$message.error('获取验证码失败');
        });
      }
    },

    handleConfirm() {
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      // 触发确认事件，将验证码传递给父组件
      this.$emit('confirm', this.code);
    },

    handleCancel() {
      this.$emit('cancel');
      this.dialogVisible = false;
    },

    handleClose() {
      this.resetDialog();
    },

    resetDialog() {
      this.code = "";
      this.phone = "";
      this.clearTimer();
      this.countdown = 60;
      this.codeDisabled = false;
      this.codeMsg = "获取验证码";
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },

  beforeDestroy() {
    this.clearTimer();
  }
};
</script>

<style lang="scss" scoped>
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }

  .form-box {
    padding-top: 16px;

    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;

      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }

      .item-label2 {
        display: inline-block;
        width: 100px;
        text-align: right;
      }

      .item-value {
        display: inline-block;
      }
    }
  }

  .save-btn {
    text-align: center;
  }
}

.tip-box {
  height: 20px;
}
</style>